import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const bestoddsColors: ThemeTailwindType = {
    '--primary': '48 100% 47%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '222 47% 11%',
};

const colorPalette: ColorPaletteType = {
    primary: '#18213a',
    secondary: '#39b54a',
    tertiary: '#ccff62',
    dark: '#141c31',
    shade1: '#2a334a',
    shade2: '#343c52',
    shade3: '#3d455a',
    shade4: '#464d61',
    shade5: '#4f5669',
    shade6: '#f6f6f7',
    textDark: '#141c31',
    textTertiary: '#ccff62',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.tertiary,

        borderColor: colorPalette.tertiary,
        borderColorSecondary: colorPalette.tertiary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.tertiary,
        txtColorTertiary: colorPalette.dark,
        txtColorQuaternary: colorPalette.dark,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#141c31',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#39b54a',
        buttonTxtColor: '#141c31',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
